<template>
  <div v-bind="$attrs">
    <CustomSwitchWrapper
      class="mb-2"
      data-test-id="allow-attachments"
      :disabled="!canEnableAttachments || createStore.isEnvelope"
      :initial-value="signeeAttachmentsAllowed"
      :label="String(i18n.t('labels.allow_attachments'))"
      label-class="drawer-subhead"
      :switch-id="i18n.t('labels.allow_attachments')"
      @value-changed="setSigneeAttachmentsAllowed"
    >
      <template #label-append>
        <span class="ml-1">
          <v-menu
            location="left top"
            max-width="300"
            open-on-click
            open-on-hover
          >
            <template #activator="{ props: ActivatorProps }">
              <v-icon
                v-bind="ActivatorProps"
                aria-label="Attachments hint"
                class="icon"
                color="grey"
                size="13"
              >
                far fa-circle-info
              </v-icon>
            </template>
            <v-card class="pa-3" flat>
              <v-card-text v-if="!createStore.isEnvelope" class="pa-0">
                {{
                  canEnableAttachments
                    ? i18n.t('texts.allow_attachments_hint')
                    : i18n.t('texts.allow_attachments_disabled_hint')
                }}
              </v-card-text>
              <v-card-text v-else class="pa-0">
                {{ i18n.t('texts.disallow_signee_attachments_hint') }}
              </v-card-text>
            </v-card>
          </v-menu>
        </span>
      </template>
    </CustomSwitchWrapper>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import CustomSwitchWrapper from '@/components/inputs/CustomSwitchWrapper.vue';
import { useSigningWorkflow } from '@/composables/create/useSigningWorkflow';

import { useCreateStore } from '@/stores/create';

defineOptions({
  inheritAttrs: false
});

const i18n = useI18n();
const {
  signeeAttachmentsAllowed,
  canEnableAttachments,
  setSigneeAttachmentsAllowed
} = useSigningWorkflow();
const createStore = useCreateStore();

watch(canEnableAttachments, (enabled) => {
  if (signeeAttachmentsAllowed.value && !enabled) {
    setSigneeAttachmentsAllowed(false);
  }
});
</script>
